module.exports = __webpack_public_path__ + "static/img/invite_title.0d19926.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/invitation/invite_title.png
// module id = mXS6
// module chunks = 1